import React, { useState } from "react";
import { Send, Trash2 } from "lucide-react";

export function InfobipTestRow({ busy, sendTest, disconnect }) {
  const [testEmail, setTestEmail] = useState("");
  return (
    <div className="flex items-center gap-2 flex-wrap pt-2 border-t border-zinc-800">
      <div className="flex items-center gap-2 flex-1 max-w-md">
        <input data-testid="infobip-test-email-input" type="email" value={testEmail} onChange={(e) => setTestEmail(e.target.value)} placeholder="test recipient email" className="flex-1 bg-zinc-950 border border-zinc-800 rounded-sm px-3 py-1.5 text-xs mono outline-none" />
        <button data-testid="infobip-send-test-btn" onClick={() => sendTest(testEmail)} disabled={busy || !testEmail.trim()} className="inline-flex items-center gap-1 border border-sky-700 text-sky-300 hover:border-sky-400 hover:text-sky-200 px-3 py-1.5 rounded-sm text-xs font-medium disabled:opacity-50">
          <Send size={12} /> Send test
        </button>
      </div>
      <button data-testid="infobip-disconnect-btn" onClick={disconnect} disabled={busy} className="inline-flex items-center gap-1 text-zinc-500 hover:text-red-400 px-2 py-1.5 rounded-sm text-xs font-medium ml-auto disabled:opacity-50">
        <Trash2 size={12} /> Disconnect + delete DNS
      </button>
    </div>
  );
}
